<script setup lang="ts">
/**
 * In this component, the conversation id is guaranteed to exist. We key this component by the conversation id as well to ensure that it fully recreates in the case of a new conversation
 */
const props = defineProps({
  conversationId: null
})

const { mergedTranscript, getReactiveConversation } = useConversations()

const conversation = getReactiveConversation(props.conversationId, "agent", true)!

if (!conversation)
  throw new Error(`No conversation found for id ${props.conversationId}`)

const transcript = computed(() => mergedTranscript(conversation.asStatic()))
</script>

<template>
  <div class="agent-conversation">
    <agent-transcript :transcript />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.agent-conversation
  @apply h-full w-full
</style>
